import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class UtilsAdminService {

  constructor() { }

  confirmarSincronoPromesaMenu(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        // input: 'text',
        text: `${params.text || ''}`,
        html: `
        <div class="form-group">
          <label for="descripcion">Descripción</label>
          <input value="${params.data.descripcion}" type="text" class="form-control" id="descripcion" placeholder="Ingrese Descripción">
        </div>
        <br>
        <div class="form-group">
          <label for="orden">Orden</label>
          <input value="${params.data.orden}" type="number" class="form-control" id="orden" placeholder="Ingrese Orden">
        </div>
        `,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Editar',
        preConfirm: () => {
          const descripcion = Swal.getPopup().querySelector('#descripcion')['value'];
          const orden = Swal.getPopup().querySelector('#orden')['value'];
          if (!descripcion || !orden) {
            Swal.showValidationMessage(`Los campos Orden y Descripción son obligatorios.`)
          }
          return { descripcion: descripcion, orden: orden }
        }
      }).then((result: any) => {
        if (result.value) {
          params.funcion.subscribe((resp) => {
            Swal.fire(
              `${params.action}`,
              result.value,
              'success'
            );
            resolve(result.value);
          });
        }
      });
    });
  }
}
